module.exports = __webpack_public_path__ + "static/media/Pinwheel Logo.b4e401ff.png";